import React from 'react';

import { UserIdentification } from 'shared/presentation/components/templates';
import { Redirect, useActiveCustomer } from 'shared/presentation/contexts';

const NewSchedule: React.FC = () => {
  const { customer } = useActiveCustomer();

  if (!customer) {
    return <UserIdentification />;
  }

  return <Redirect to="/schedules" params={{}} />;
};

export default NewSchedule;
